module.exports = __webpack_public_path__ + "static/media/questions_library.87cafc23.png";